import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ScheduleMeeting.css";
import Dashboard from "../Dashboard/Dashboard";
import achi from "../../images/calender-svg.svg";
import clock from "../../images/clock.svg";
import meet from "../../images/meet.png";
import zoom from "../../images/zoom.png";
import { useNavigate } from "react-router-dom";
import ZoomModal from "../ZoomModal/ZoomModal";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { END_URL, IMG_URL } from "../../config";
import loadimg from "../../images/loader_wish.gif";
import buttonloader from "../../images/buttonloader.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ScheduleSkeleton from "../ScheduleMeeting/ScheduleSkeleton";
import Subscriptions from "../Subscriptions/Subscriptions";

const SuccessModal = ({ onClose }) => (
  <div className="modal-overlay schedule-modal">
    <div className="modal-content">
      <h4>Success!</h4>
      <p>Schedule submitted successfully!</p>
      <button onClick={onClose}>OK</button>
    </div>
  </div>
);
const AlreadySelectedModal = ({ onClose }) => (
  <div className="modal-overlay">
    <div className="modal-content">
      <h4>Notice</h4>
      <p>You already selected this slot.</p>
      <button onClick={onClose}>OK</button>
    </div>
  </div>
);

function ScheduleMeeting({ onLoginChange, globaltest, userdetail }) {
  const [ButtonLoad, setButtonLoad] = useState(false);

  const navigate = useNavigate();

  const [isModalOpen, setModalOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const [selectedId, setselectedId] = useState(null);

  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userZoomStatus, setUserZoomStatus] = useState(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isAlreadySelectedModalOpen, setIsAlreadySelectedModalOpen] =
    useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const token = localStorage.getItem("token");

  const [isseleted, setisseleted] = useState(false);

  const [isEdit, setisEdit] = useState(false);

  const [FreeTestAttend, setFreeTestAttend] = useState(false);

  const [FreeTestSub, setFreeTestSub] = useState(false);

  const [FreeTest, setFreeTest] = useState({});

  const [showPopup, setshowPopup] = useState(false);

  const [showFreeSub, setshowFreeSub] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [BannerContent, setBannerContent] = useState("");

  const [ActiveBookings, setActiveBookings] = useState([]);

  const [BookingHistory, setBookingHistory] = useState(false);

  const [BookingId, setBookingId] = useState(null);

  const [HistoryLabel, setHistoryLabel] = useState("");

  const insufficient = false;

  const reason = null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!token) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      onLoginChange(true);
    }
  }, [token]);

  const handleSub = async (subJson) => {
    try {
      let subIds = [];

      if (typeof subJson === "string") {
        try {
          subIds = JSON.parse(subJson);
        } catch (e) {
          console.error("Invalid JSON string for subIds:", e);
          return;
        }
      } else if (Array.isArray(subJson)) {
        subIds = subJson;
      }

      setshowFreeSub(false);

      setShowModal(true);

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  useEffect(() => {
    // Fetch schedules

    setLoading(true);

    axios
      .get(`${END_URL}/zoom`)
      .then((response) => {
        setSchedules(response.data);
      })
      .catch((error) => {
        setError(error.message);
      });

    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(`${END_URL}/user/zoom-status`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUserZoomStatus(response.data);

          if (response.data.zoom_id != null && !response.data.link_expire) {
            setIsSubmitted(true);

            if (response.data.zoom_schedule_status === "approved") {
              setIsApproved(true);
            }
          }

          setActiveBookings(response?.data?.active_bookings);

          setBookingHistory(response?.data?.booking_history);

          setHistoryLabel(response?.data?.all_zoom_metting);

          setFreeTestAttend(response?.data?.user_attent_free_test);

          setFreeTestSub(response?.data?.user_have_free_test_sub);

          setFreeTest(response.data.test);

          setBannerContent(response.data.personlity_mapping_content || "");

          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching user status:", error);
        });
    }
  }, []);

  const copyZoomLink = (zoom_meeting_link) => {
    if (zoom_meeting_link) {
      navigator.clipboard
        .writeText(zoom_meeting_link)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 1000); // Hide after 2 seconds
        })
        .catch((err) => {
          console.error("Failed to copy link:", err);
        });
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
    if (schedules.length > 0) {
      const firstDate = schedules[0].date;
      const parsedDate = new Date(firstDate);
      setSelectedDate(parsedDate);

      setselectedId(schedules[0].id);
    } else {
      setSelectedDate(null);
      setselectedId(null);
    }
    setSelectedTime(null);

    setisseleted(false);
  };

  const handleSubmit = async () => {
    if (!selectedSchedule) return;
    // console.log("ID:", selectedSchedule.id);
    // console.log("Date:", selectedSchedule.date);
    // console.log("Start Time:", selectedSchedule.starttime);
    // console.log("End Time:", selectedSchedule.endtime);
    // console.log("Edit Mode:", isEdit);
    // console.log("BookingId Mode:", BookingId);

    // return 0;
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${END_URL}/user/zoom-schedule`,
        {
          selected_id: selectedSchedule.id,
          selected_zoom_date: selectedSchedule.date,
          selected_zoom_starttime: selectedSchedule.starttime,
          selected_zoom_endtime: selectedSchedule.endtime,
          edit: isEdit,
          booking_id: BookingId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setIsSubmitted(true);

      if (response.data.zoom_schedule_status === "approved") {
        setIsApproved(true);
      }

      const statusRes = await axios.get(`${END_URL}/user/zoom-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUserZoomStatus(statusRes.data);
      setActiveBookings(statusRes?.data?.active_bookings);
      setBookingHistory(statusRes?.data?.booking_history);
      setHistoryLabel(statusRes?.data?.all_zoom_metting);

      setModalOpen(false);

      setSelectedDate(null);

      setselectedId(null);

      setSelectedTime(null);

      setisseleted(false);

      setIsSuccessModalOpen(true);
    } catch (error) {
      console.error("Error saving schedule:", error);
      setIsAlreadySelectedModalOpen(true);
    }
  };

  function formatTime(timeStr) {
    if (!timeStr || timeStr.includes("AM") || timeStr.includes("PM")) {
      return timeStr;
    }
    // Handle raw time (e.g., "12:30:00" or "12:30")
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  }

  // Helper to format date (e.g., "March 12, 2025")
  function formatDate(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  // Filter schedules by selected date
  const timesForSelectedDate = selectedDate
    ? schedules.filter((s) => {
        const selectedDateStr = selectedDate.toLocaleDateString("en-CA");

        return s.date === selectedDateStr;
      })
    : [];

  // When a time slot is selected
  const handleTimeSelect = (schedule) => {
    setSelectedTime(schedule);
    setSelectedSchedule(schedule);
    setisseleted(true);
  };

  // When modal opens, reset selections
  const openModal = () => {
    setModalOpen(true);

    setisEdit(false);

    if (schedules.length > 0) {
      const firstDate = schedules[0].date;
      const parsedDate = new Date(firstDate);
      setSelectedDate(parsedDate);
      setselectedId(schedules[0].id);
    } else {
      setSelectedDate(null);
      setselectedId(null);
    }

    setSelectedTime(null);
  };

  const HandlePayment = (item) => {
    const InitializePayment = async () => {
      try {
        setButtonLoad(true);

        const response = await fetch(`${END_URL}/test-payment`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },

          body: JSON.stringify(item),
        });

        const data = await response.json();

        console.log(data.payment, "fetch data");

        if (data.payment) {
          setButtonLoad(false);
          window.location.href = data.payment;
        } else {
          setButtonLoad(false);

          console.error("Invalid response:", data);
          alert("An error occurred while processing the request.");
        }
      } catch (error) {
        console.error("Error sending result:", error);
      }
    };

    InitializePayment();
  };

  const AttentTest = () => {
    setshowPopup(true);
  };

  const TakeFreeSub = () => {
    setshowFreeSub(true);
  };

  const handleEdit = (BookingId) => {
    setisEdit(true);

    setModalOpen(true);

    setBookingId(BookingId);

    if (userZoomStatus?.selected_zoom_date) {
      const parsedDate = new Date(userZoomStatus.selected_zoom_date);
      setSelectedDate(parsedDate);

      setselectedId(userZoomStatus.id);
    } else {
      setSelectedDate(null);

      setselectedId(null);
    }

    if (
      userZoomStatus?.selected_zoom_starttime &&
      userZoomStatus?.selected_zoom_endtime
    ) {
      const matchingSchedule = schedules.find(
        (s) =>
          s.date === userZoomStatus.selected_zoom_date &&
          s.starttime === userZoomStatus.selected_zoom_starttime &&
          s.endtime === userZoomStatus.selected_zoom_endtime,
      );
      setSelectedTime(matchingSchedule);
      setSelectedSchedule(matchingSchedule);
      setisseleted(true);
    }
  };

  return (
    <div>
      <div className="result-cont schedule-cont">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
              <Dashboard globaltest={globaltest} />
            </div>

            <div className="col-12 col-sm-12 col-md-9 col-lg-9 schedule">
              {loading ? (
                <ScheduleSkeleton />
              ) : (
                <>
                  <div className="row deep-content-row">
                    <div
                      className="deep-pop-text"
                      dangerouslySetInnerHTML={{ __html: BannerContent }}
                    />
                  </div>

                  <div className="schedule-inner">
                    <div className="schedule-btn">
                      <h5>Available Schedules</h5>

                      {!isSubmitted &&
                        userZoomStatus?.zoom_active &&
                        userZoomStatus?.zoom &&
                        (FreeTestSub || userdetail?.user_all_access == 1 ? (
                          FreeTestAttend && FreeTestSub ? (
                            <button onClick={openModal}>
                              Select Date & Time{" "}
                            </button>
                          ) : (
                            <button onClick={() => AttentTest()}>
                              Select Date & Time
                            </button>
                          )
                        ) : (
                          <button onClick={() => TakeFreeSub()}>
                            Select Date & Time
                          </button>
                        ))}

                      {
                        userZoomStatus?.user_can_attend &&
                          (!isSubmitted && FreeTestSub ? (
                            FreeTestAttend ? (
                              !userZoomStatus?.zoom &&
                              !userZoomStatus?.zoom_active && (
                                <button
                                  // onClick={() => HandlePayment(userZoomStatus.sub_plan)}

                                  onClick={() =>
                                    handleSub([userZoomStatus.sub_plan?.id])
                                  }
                                >
                                  Select Date & Time{" "}
                                  {ButtonLoad && (
                                    <img
                                      src={buttonloader}
                                      alt="Loading"
                                      style={{
                                        marginLeft: "0px",
                                        width: "33px",
                                        height: "33px",
                                      }}
                                    />
                                  )}{" "}
                                </button>
                              )
                            ) : (
                              <button onClick={() => AttentTest()}>
                                Select Date & Time
                              </button>
                            )
                          ) : (
                            !isSubmitted && (
                              <button onClick={() => TakeFreeSub()}>
                                Select Date & Time
                              </button>
                            )
                          ))
                        // }
                      }
                    </div>

                    {ActiveBookings &&
                      ActiveBookings.length > 0 &&
                      ActiveBookings?.map((item) => (
                        <div
                          className={`schedule-approve ${item?.status == "pending" ? "schedule-waiting" : ""} `}
                        >
                          <div className="schedule-approve-list">
                            <div className="schedule-one">
                              <span>Selected Date</span>
                              <span>
                                {/* {userZoomStatus?.selected_zoom_date
                                                        ? formatDate(userZoomStatus.selected_zoom_date)
                                                        : 'Not selected'} */}

                                {item?.meeting_date
                                  ? formatDate(item?.meeting_date)
                                  : "Not selected"}
                              </span>
                            </div>
                            <div className="schedule-one">
                              <span>Time</span>
                              <span>
                                {/* {userZoomStatus?.selected_zoom_starttime && userZoomStatus?.selected_zoom_endtime
                                                        ? `${formatTime(userZoomStatus.selected_zoom_starttime)} - ${formatTime(userZoomStatus.selected_zoom_endtime)}`
                                                        : 'Not selected'} */}

                                {item?.zoom?.starttime && item?.zoom?.endtime
                                  ? `${formatTime(item?.zoom?.starttime)} - ${formatTime(item?.zoom?.endtime)}`
                                  : "Not selected"}
                              </span>
                            </div>

                            <div className="schedule-one">
                              <span>Status</span>

                              {item?.status == "pending" ? (
                                <button className="schedule-b1">
                                  Waiting For Approval
                                </button>
                              ) : (
                                <button className="schedule-b1">
                                  APPROVED
                                </button>
                              )}
                            </div>

                            {item?.status == "pending" ? (
                              <div className="schedule-one">
                                <span>Actions</span>
                                <button
                                  onClick={() => handleEdit(item?.id)}
                                  className="schedule-b2"
                                >
                                  Edit
                                </button>
                              </div>
                            ) : (
                              <div className="schedule-remider">
                                <div className="schedule-approve-google">
                                  <label htmlFor="">Meeting Link</label>
                                  <div
                                    className="schedule-meet-link"
                                    onClick={() =>
                                      copyZoomLink(item?.zoom_meeting_link)
                                    }
                                    style={{
                                      cursor: item?.zoom_meeting_link
                                        ? "pointer"
                                        : "default",
                                    }}
                                  >
                                    <img src={meet} alt="" />
                                    <span>
                                      {item?.zoom_meeting_link
                                        ? item.zoom_meeting_link
                                        : "Not set"}
                                    </span>
                                  </div>
                                  {isCopied && (
                                    <div className="copied-text">Copied!</div>
                                  )}
                                </div>

                                {item?.remainder && (

                                    <div className="schedule-one schedule-one-reminder">
                                      <span>Reminder</span>

                                      <div
                                        className="schedule-reminder-bottom"
                                        dangerouslySetInnerHTML={{
                                          __html: item?.remainder,
                                        }}
                                      />
                                    </div>
                                )}
                              
                              </div>
                            )}

                          </div>
                          
                          {item?.status == "pending" && (

                            item?.remainder && (
                              
                                <div className="schedule-one schedule-one-reminder schedule-one-reminder-single">
                                  <span>Reminder</span>

                                  <div
                                    className="schedule-reminder-bottom"
                                    dangerouslySetInnerHTML={{
                                      __html: item?.remainder,
                                    }}
                                  />
                                </div>
                              )

                          )}

                        </div>
                      ))}

                    {Array.isArray(ActiveBookings) &&
                      ActiveBookings.length === 0 && (
                        <div className="schedule-inner2">
                          <div>
                            <img src={zoom} alt="" />
                          </div>
                        </div>
                      )}
                  </div>
                </>
              )}

              {BookingHistory && (
                <div className="ques-btn view-all-meetings">
                  <a className="nav-head-out-btn combine-btn view-all-meetings-btn">
                    <button
                      className="nav-head-out-btn-text view-all-meetings-btn-link"
                      onClick={() => navigate("/zoom-meetings")}
                    >
                      {HistoryLabel}

                      <span>
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                      </span>
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="newdashpop-overlay subs-cognit-modal1 ">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => setshowPopup(false)}
              >
                &times;
              </button>

              <div
                className="conent-pop"
                dangerouslySetInnerHTML={{
                  __html: FreeTest?.not_attend_free_test,
                }}
              />

              <a
                className="home-slider-sun-box-a"
                href={`test/${FreeTest?.slug}`}
                rel="noopener noreferrer"
              >
                <span className="home-slider-sun-box-a-text">
                  {FreeTest?.not_attend_free_test_label}
                </span>
                <span className="home-slider-sun-box-a-icon">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>
            </div>
          </div>
        </div>
      )}

      {showFreeSub && (
        <div className="newdashpop-overlay subs-cognit-modal1 schedule-zoom-mdl">
          <div className="newdashpop-inner">
            <div className="newdashpop-container  sub-no">
              <button
                className="newdashpop-close"
                onClick={() => setshowFreeSub(false)}
              >
                &times;
              </button>

              <div className="conent-pop subs-left">
                <div
                  className="conent-pop-text"
                  dangerouslySetInnerHTML={{
                    __html: FreeTest?.not_have_free_test_pms,
                  }}
                />

                <button
                  // onClick={() => HandlePayment(FreeTest?.sub)}

                  onClick={() =>
                    handleSub(FreeTest?.not_have_free_test_sub_link)
                  }
                >
                  {FreeTest?.not_have_free_test_label}
                  <span>
                    {!ButtonLoad && (
                      <FontAwesomeIcon className="icc" icon={faArrowRight} />
                    )}
                  </span>{" "}
                  {ButtonLoad && <img src={buttonloader} alt="Loading" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <ZoomModal onClose={handleCancel}>
          <h4>Available Schedules</h4>

          <div className="zoom-modal-text">
            <div className="zoom-ip">
              <div className="zoom-date">
                <span>Date</span>
                <span>
                  {selectedDate
                    ? formatDate(selectedDate.toISOString())
                    : "Not selected"}
                </span>
              </div>
              <div className="zoom-time">
                <span>Time</span>
                <span>
                  {selectedTime
                    ? `${formatTime(selectedTime.starttime)} - ${formatTime(selectedTime.endtime)}`
                    : "Not selected"}
                </span>
              </div>
            </div>
            <div className="zoom-modal-dt-div">
              <div className="row zoom-dt-row">
                <div className="co-12 col-sm-7 col-md-6 zoom-col-date">
                  <div className="zoom-full-calender">
                    <Calendar
                      onChange={setSelectedDate}
                      value={selectedDate}
                      tileDisabled={({ date }) => {
                        const dateStr = date.toLocaleDateString("en-CA");

                        return !schedules.some((s) => s.date === dateStr);
                      }}
                    />
                  </div>
                </div>
                <div className="co-12 col-sm-5 col-md-6 zoom-col-time">
                  <div className="zoom-slot-timing">
                    {selectedDate &&
                      timesForSelectedDate.map((schedule) => (
                        <button
                          key={schedule.id}
                          onClick={() => handleTimeSelect(schedule)}
                          className={
                            selectedTime?.id === schedule.id ? "active" : ""
                          }
                          disabled={schedule.status === "booked"}
                        >
                          {formatTime(schedule.starttime)} -{" "}
                          {formatTime(schedule.endtime)}
                          {schedule.status === "booked" && " (Booked)"}
                        </button>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {isseleted && selectedSchedule && (
              <div className="zoom-btns">
                <button className="schedule-a cancel" onClick={handleCancel}>
                  Cancel
                </button>

                <button
                  className="schedule-a submit"
                  onClick={handleSubmit}
                  disabled={!selectedSchedule}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </ZoomModal>
      )}
      {isSuccessModalOpen && (
        <SuccessModal onClose={() => setIsSuccessModalOpen(false)} />
      )}
      {isAlreadySelectedModalOpen && (
        <AlreadySelectedModal
          onClose={() => setIsAlreadySelectedModalOpen(false)}
        />
      )}

      {ShowModal && (
        <div
          className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
            subscription?.data?.length == 1 ? "single-subscription" : ""
          }`}
        >
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>

              <div className="conent-pop">
                <Subscriptions
                  insufficientPayment={insufficient}
                  reason={reason}
                  subs={subS}
                  userdetail={userdetail}
                  Subcription={subscription}
                  onLoginChange={onLoginChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScheduleMeeting;
